import shortid from "shortid";
import { useState } from "react";
import {
  Button,
  Grid,
  TextField,
  IconButton,
  Tooltip,
  Typography,
  Divider,
  Box,
  FormControlLabel,
  Switch,
} from "../../../../../components";

function PainelCadastro({
  icone,
  titulo,
  placeholder,
  itens,
  selecionadoId,
  onSelecionar,
  onAdicionar,
  onEditar,
  onRemover,
  handleUpdateObrigatoriedade,
}) {
  const [inputNome, setInputNome] = useState("");
  const [emEdicao, setEmEdicao] = useState(false);
  const [idEmEdicao, setIdEmEdicao] = useState(null);

  const handleIniciarEdicao = (item) => {
    setInputNome(item.descricao);
    setIdEmEdicao(item.id);
    setEmEdicao(true);
  };

  const handleCancelar = () => {
    setInputNome("");
    setIdEmEdicao(null);
    setEmEdicao(false);
  };

  const handleSubmit = () => {
    if (!inputNome.trim()) return;
    if (emEdicao) {
      onEditar(idEmEdicao, inputNome.trim());
    } else {
      onAdicionar(inputNome.trim());
    }
    setInputNome("");
    setIdEmEdicao(null);
    setEmEdicao(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSubmit();
    if (e.key === "Escape") handleCancelar();
  };

  return (
    <Box className="d-flex flex-column h-100" style={{ minHeight: 0 }}>
      <Box className="d-flex align-items-center gap-2 mb-3">
        <i
          className={`ph-bold ${icone}`}
          style={{ fontSize: 16, color: "#555" }}
        />
        <Typography
          variant="subtitle2"
          style={{
            fontSize: 12,
            fontWeight: 700,
            textTransform: "uppercase",
            letterSpacing: 0.8,
            color: "#444",
            flex: 1,
          }}
        >
          {titulo}
        </Typography>
        <span
          style={{
            fontSize: 11,
            fontWeight: 700,
            backgroundColor: "#e0e0e0",
            color: "#555",
            borderRadius: 10,
            padding: "1px 8px",
            minWidth: 22,
            textAlign: "center",
          }}
        >
          {itens.length}
        </span>
      </Box>
      <Box className="d-flex gap-2 mb-3">
        <TextField
          size="small"
          fullWidth
          placeholder={
            emEdicao ? `Editar ${placeholder.toLowerCase()}...` : placeholder
          }
          value={inputNome}
          onChange={(e) => setInputNome(e.target.value)}
          onKeyDown={handleKeyDown}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
              backgroundColor: "#fafafa",
            },
          }}
        />
        <Tooltip
          title={emEdicao ? "Salvar edição (Enter)" : "Adicionar (Enter)"}
        >
          <Button
            variant="contained"
            color="primary"
            disableElevation
            onClick={handleSubmit}
            style={{
              minWidth: 38,
              padding: 10,
              borderRadius: 8,
            }}
          >
            <i
              className={`ph-bold ${emEdicao ? "ph-check" : "ph-plus"}`}
              style={{ color: "white", fontSize: 15 }}
            />
          </Button>
        </Tooltip>
        {emEdicao && (
          <Tooltip title="Cancelar (Esc)">
            <Button
              variant="outlined"
              color="padrao"
              disableElevation
              onClick={handleCancelar}
              style={{
                minWidth: 38,
                paddingInline: 10,
                borderRadius: 8,
                alignSelf: "stretch",
              }}
            >
              <i className="ph-bold ph-x" style={{ fontSize: 15 }} />
            </Button>
          </Tooltip>
        )}
      </Box>
      <Divider />
      <Box
        style={{
          flex: 1,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          gap: 4,
          paddingTop: 10,
        }}
      >
        {!itens.length && (
          <Typography
            variant="body2"
            className="text-muted text-center mt-3"
            style={{ fontSize: 12 }}
          >
            Nenhum item cadastrado.
          </Typography>
        )}
        {itens.map((item) => {
          const selecionado = item.id === selecionadoId;
          return (
            <Box
              key={item.id}
              onClick={() => onSelecionar && onSelecionar(item.id)}
              className="d-flex align-items-center justify-content-between px-3 py-2 rounded"
              style={{
                cursor: onSelecionar ? "pointer" : "default",
                backgroundColor: selecionado ? "#e8f4fd" : "#ffffff",
                border: selecionado ? "1px solid #90caf9" : "1px solid #eeeeee",
                transition: "all 0.15s",
                userSelect: "none",
              }}
            >
              <Box
                className="d-flex align-items-center gap-2"
                style={{ flex: 1, minWidth: 0 }}
              >
                {onSelecionar && (
                  <i
                    className={
                      selecionado
                        ? "ph-fill ph-check-circle"
                        : "ph-bold ph-circle"
                    }
                    style={{
                      fontSize: 16,
                      color: selecionado ? "#1976d2" : "#ccc",
                      flexShrink: 0,
                    }}
                  />
                )}
                <Typography
                  variant="body2"
                  style={{
                    fontSize: 13,
                    fontWeight: selecionado ? 600 : 400,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    color: selecionado ? "#1565c0" : "inherit",
                  }}
                >
                  {item.descricao}
                </Typography>
              </Box>
              <Box className="d-flex gap-1 ms-2">
                {titulo.includes("Componente") && (
                  <FormControlLabel
                    control={
                      <Switch
                        checked={item.obrigatoriedade ?? false}
                        onChange={(e) => {
                          e.stopPropagation();
                          handleUpdateObrigatoriedade(
                            item.id,
                            e.target.checked,
                          );
                        }}
                        color="primary"
                        size="small"
                      />
                    }
                    label={
                      <Typography
                        variant="body2"
                        sx={{ fontSize: "0.8rem", ml: 0.5 }}
                      >
                        {item.obrigatoriedade ? "Obrigatório" : "Opcional"}
                      </Typography>
                    }
                  />
                )}
                <Tooltip title="Editar">
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleIniciarEdicao(item);
                    }}
                    style={{ padding: 4 }}
                  >
                    <i className="ph-fill ph-pencil" style={{ fontSize: 14 }} />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Remover">
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      onRemover(item.id);
                    }}
                    style={{ padding: 4 }}
                  >
                    <i className="ph-fill ph-trash" style={{ fontSize: 14 }} />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}

export function AvariasAtivoConfiguracao({
  locais,
  setLocais,
  tiposAvaria,
  setTiposAvaria,
}) {
  const [localSelecionadoId, setLocalSelecionadoId] = useState(null);

  const localSelecionado =
    locais.find((l) => l.id === localSelecionadoId) ?? null;

  const handleAdicionarLocal = (descricao) => {
    setLocais((prev) => [
      ...prev,
      { id: shortid.generate(), descricao, componentes: [] },
    ]);
  };

  const handleEditarLocal = (id, descricao) => {
    setLocais((prev) =>
      prev.map((l) => (l.id === id ? { ...l, descricao } : l)),
    );
  };

  const handleRemoverLocal = (id) => {
    setLocais((prev) => prev.filter((l) => l.id !== id));
    if (localSelecionadoId === id) setLocalSelecionadoId(null);
  };

  const handleUpdateObrigatoriedade = (id, obrigatoriedade) => {
    setLocais((prev) =>
      prev.map((l) =>
        l.id === localSelecionadoId
          ? {
              ...l,
              componentes: l.componentes.map((c) =>
                c.id === id ? { ...c, obrigatoriedade } : c,
              ),
            }
          : l,
      ),
    );
  };

  const handleSelecionarLocal = (id) => {
    setLocalSelecionadoId((prev) => (prev === id ? null : id));
  };

  const handleAdicionarComponente = (nome) => {
    if (!localSelecionadoId) return;
    setLocais((prev) =>
      prev.map((l) =>
        l.id === localSelecionadoId
          ? {
              ...l,
              componentes: [
                ...l.componentes,
                { id: shortid.generate(), descricao: nome, obrigatoriedade: false },
              ],
            }
          : l,
      ),
    );
  };

  const handleEditarComponente = (id, descricao) => {
    setLocais((prev) =>
      prev.map((l) =>
        l.id === localSelecionadoId
          ? {
              ...l,
              componentes: l.componentes.map((c) =>
                c.id === id ? { ...c, descricao } : c,
              ),
            }
          : l,
      ),
    );
  };

  const handleRemoverComponente = (id) => {
    setLocais((prev) =>
      prev.map((l) =>
        l.id === localSelecionadoId
          ? { ...l, componentes: l.componentes.filter((c) => c.id !== id) }
          : l,
      ),
    );
  };

  const handleAdicionarTipoAvaria = (descricao) => {
    setTiposAvaria((prev) => [...prev, { id: shortid.generate(), descricao }]);
  };

  const handleEditarTipoAvaria = (id, descricao) => {
    setTiposAvaria((prev) =>
      prev.map((t) => (t.id === id ? { ...t, descricao } : t)),
    );
  };

  const handleRemoverTipoAvaria = (id) => {
    setTiposAvaria((prev) => prev.filter((t) => t.id !== id));
  };

  return (
    <Box>
      <Box
        className="d-flex align-items-center gap-2 px-3 py-2 my-3 rounded"
        style={{
          backgroundColor: "#f0f7ff",
          border: "1px solid #c5dff8",
          fontSize: 13,
          color: "#444",
        }}
      >
        <i
          className="ph-bold ph-info"
          style={{ fontSize: 15, color: "#1976d2", flexShrink: 0 }}
        />
        <span>
          Selecione um <strong>Local</strong> para gerenciar seus{" "}
          <strong>Componentes</strong>. Os <strong>Tipos de Avaria</strong> são
          compartilhados entre todos os locais.
        </span>
      </Box>

      <Grid container spacing={2} className="my-1">
        <Grid
          item
          xs={4}
          style={{
            borderRight: "1px solid #e0e0e0",
            paddingRight: 16,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <PainelCadastro
            icone="ph-map-pin"
            titulo="Locais do Ativo"
            placeholder="Novo local..."
            itens={locais}
            selecionadoId={localSelecionadoId}
            onSelecionar={handleSelecionarLocal}
            onAdicionar={handleAdicionarLocal}
            onEditar={handleEditarLocal}
            onRemover={handleRemoverLocal}
          />
        </Grid>
        <Grid
          item
          xs={4}
          style={{
            borderRight: "1px solid #e0e0e0",
            paddingRight: 16,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {localSelecionado ? (
            <PainelCadastro
              icone="ph-stack"
              titulo={`Componentes — ${localSelecionado.descricao}`}
              placeholder="Novo componente..."
              itens={localSelecionado.componentes}
              selecionadoId={null}
              onSelecionar={null}
              onAdicionar={handleAdicionarComponente}
              onEditar={handleEditarComponente}
              onRemover={handleRemoverComponente}
              handleUpdateObrigatoriedade={handleUpdateObrigatoriedade}
            />
          ) : (
            <Box className="d-flex flex-column align-items-center justify-content-center h-100 gap-2">
              <i
                className="ph-bold ph-stack"
                style={{ fontSize: 28, color: "#ccc" }}
              />
              <Typography
                variant="body2"
                className="text-muted text-center"
                style={{ fontSize: 12 }}
              >
                Selecione um local para gerenciar seus componentes.
              </Typography>
            </Box>
          )}
        </Grid>

        <Grid item xs={4} style={{ display: "flex", flexDirection: "column" }}>
          <PainelCadastro
            icone="ph-wrench"
            titulo="Tipos de Avaria"
            placeholder="Novo tipo..."
            itens={tiposAvaria}
            selecionadoId={null}
            onSelecionar={null}
            onAdicionar={handleAdicionarTipoAvaria}
            onEditar={handleEditarTipoAvaria}
            onRemover={handleRemoverTipoAvaria}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
